<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ART &HUMANITIES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Yoga Science</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Diploma</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Arts in Yoga</td>
                            <td class="time">Diploma in Panchkarma</td>
                        </tr>
                        <tr>
                            <td class="time">Bachelor of Science in Yoga</td>
                            <td class="time"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Yoga Science</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Arts in Yoga </b>
                    – The Bachelor of Arts in Yoga (BA Yoga) at ARNI University combines ancient Yogic traditions with
                    contemporary perspectives on health, wellness, and philosophy. This three-year undergraduate program
                    aims to provide students with an in-depth understanding of Yoga in its diverse forms—physical,
                    mental, and spiritual. Students will be equipped with practical skills, theoretical knowledge, and
                    the philosophical framework to become skilled Yoga practitioners and educators.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Foundations of Yoga</li>
                    <li> Environmental Studies</li>
                    <li> General Hindi/English</li>
                    <li> Introduction to Yoga Texts</li>
                    <li> Yoga Practical -I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Foundations of Yoga II</li>
                    <li> Foundations and Practices of Hatha Yoga</li>
                    <li> Patanjal Yoga Darshana</li>
                    <li> Yoga Anatomy Basics</li>
                    <li> Human Anatomy and Physiology</li>
                    <li> Yoga Practical -II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Principal Upanishads</li>
                    <li> Human Anatomy and Physiology II</li>
                    <li> Patanjal Yoga Darshana II</li>
                    <li> Teaching Methods in Yoga</li>
                    <li> Yoga and Psychology</li>
                    <li> Yoga Practical -III</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Introduction of Indian Yogis</li>
                    <li> Yoga and Mental Health</li>
                    <li> Bhagavad-Gita & Yoga</li>
                    <li> Elective I</li>
                    <li> Yoga Practical -IV</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Human Consciousness</li>
                    <li> Fundamentals of Naturopathy</li>
                    <li> Yoga and Human Excellence</li>
                    <li> Elective – II</li>
                    <li> Yoga Practical -V</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Yoga and Holistic Health</li>
                    <li> Applied Yoga</li>
                    <li> Research Methodology and Statistics</li>
                    <li> Elective – III</li>
                    <li> Yoga Practical -VI</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science in Yoga</b>
                    – The Bachelor of Science in Yoga (B.Sc. Yoga) at ARNI University is a comprehensive,
                    scientifically-driven program designed to equip students with the knowledge and skills necessary to
                    become expert Yoga practitioners, instructors, and therapists. This program integrates the ancient
                    wisdom of Yoga with modern scientific understanding, focusing on the physical, mental, and
                    physiological benefits of Yoga practice.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Foundation of Yoga</li>
                    <li> Introduction To Hatha Yoga</li>
                    <li> Communication Skills</li>
                    <li> Human Anatomy and Physiology</li>
                    <li> Yoga Practice – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Principal of Upanishads</li>
                    <li> Patanjali Yoga Darshana</li>
                    <li> Computer Applications</li>
                    <li> Human Anatomy & Physiology-II (Theory)</li>
                    <li> Human Anatomy & Physiology- Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Bhagavad Gita for Personality Development</li>
                    <li> Environmental Studies</li>
                    <li> Yoga and Holistic Health</li>
                    <li> Yoga Teaching Methods</li>
                    <li> Yoga Practice – II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Streams of Yoga</li>
                    <li> Yoga Therapy Basics</li>
                    <li> Biochemistry Fundamentals</li>
                    <li> AEEC- Sanskrit</li>
                    <li> Yoga Practice - III</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Indian Culture</li>
                    <li> Research Methodology & Statistics</li>
                    <li> Yogic Management of Lifestyle Disorders</li>
                    <li> Psychology Practical</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Yoga and Human Values</li>
                    <li> Yoga and Human Consciousness</li>
                    <li> Elective II</li>
                    <li> Elective III</li>
                    <li> Practice/Research</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Panchkarma</b>
                    – The Diploma in Panchkarma at ARNI University is designed to provide students with an in-depth
                    understanding of the ancient Ayurvedic healing practice of Panchkarma. This one-year diploma program
                    combines traditional Ayurvedic wisdom with modern health practices, offering practical knowledge in
                    detoxification, rejuvenation, and therapeutic therapies. Students will gain hands-on experience in
                    Panchkarma therapies and learn to treat various health conditions through the holistic approach of
                    Ayurveda.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Basic principle of Ayurveda</li>
                    <li> Definition of Panchakarma</li>
                    <li> Importance of Abhyantara and Bahya Snehana</li>
                    <li> Anatomy and Physiology in Ayurveda</li>
                    <li> Panchkarma Techniques</li>
                    <li> Preparation of Herbal Oils and Decoctions</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Advanced Panchkarma Therapies</li>
                    <li> Detoxification and Rejuvenation in Ayurveda</li>
                    <li> Psychology and Mind-Body Connection in Panchkarma</li>
                    <li> Ayurvedic Diet and Lifestyle Recommendations</li>
                    <li> Basti (Medicated Enema) Techniques</li>
                    <li> Nasya (Nasal Therapy)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Panchkarma in Common Diseases</li>
                    <li> Clinical Assessment and Patient Management</li>
                    <li> Panchkarma and its Role in Preventive Health</li>
                    <li> Herbal Formulations and Supplements in Panchkarma</li>
                    <li> Post-treatment care and Lifestyle Guidance</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Integrating Panchkarma with Modern Medicine</li>
                    <li> Management of Panchkarma Clinics</li>
                    <li> Advanced Panchkarma Techniques for Chronic Conditions</li>
                    <li> Advanced Panchkarma Practicum</li>
                    <li> Final Practicum and Internship</li>
                </ul>
            </div>



        </div>

    </div>
</section>
